import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ggStore from 'ggApp/modules/store';

import getFooterInfo from 'ggApp/shared/components/BaseLayout/Footer/info';
import Typography from 'ggApp/shared/components/typography';

import {
    Badge,
    Badges,
    BottomContainer,
    Container,
    Copyright,
    StyledLink,
    Devider,
} from './styled';

const Footer = ({ activeStore }) => {
    if (!activeStore) {
        return null;
    }

    const { activeLanguage, country_code: countryCode } = activeStore;

    const info = getFooterInfo(countryCode.toLowerCase() || 'de', activeLanguage);
    return (
        <Container>
            <Badges>
                {info.badges.map((badge) => (
                    <Badge key={badge.key} style={badge.style} alt="link badge">
                        {badge.children}
                    </Badge>
                ))}
            </Badges>
            <Devider />
            <BottomContainer>
                <Copyright>{info.copyrightText}</Copyright>
                {info.legal.links.map((item) => (
                    <StyledLink key={item.link} target="_blank" external to={item.link}>
                        <Typography tag="span">{item.text}</Typography>
                    </StyledLink>
                ))}
            </BottomContainer>
        </Container>
    );
};

Footer.propTypes = {
    activeStore: PropTypes.shape({
        activeLanguage: PropTypes.string,
        country_code: PropTypes.string,
    }).isRequired,
};

export default connect(
    createStructuredSelector({
        activeStore: ggStore.selectors.storeActive,
    }),
)(Footer);
